<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol sm="2" xs="12">
        <BaseInput
          :options="descriptionInput.options"
          :data="descriptionInput.data"
          :listener="descriptionInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)"
            >
              <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #createDate="{ item }">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>

          <template #inventoryDate="{ item }">
            <td>
              {{ $helper.formatDateDDMMYYYY(item.inventoryDate) }}
            </td>
          </template>

          <template #inventoryType="{ item }">
            <td>
              <span v-if="item.inventoryType == 'in'"> Nhập kho </span>
              <span v-if="item.inventoryType == 'out'"> Xuất kho </span>
              <div v-if="$helper.stockPurposeLabel(item.inventoryType, item.purpose)">
                {{ $helper.stockPurposeLabel(item.inventoryType, item.purpose) }}
              </div>
            </td>
          </template>

        </BaseTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseExportModal from "../base/BaseExportModal";

export default {
  name: "CheckFlow",
  components: {
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    BaseExportModal,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    return {
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      descriptionInput: {
        options: {
          placeholder: "Từ khóa",
          label: "Từ khóa",
        },
        data: {
          name: "search",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            { key: "createDate", label: "Ngày tạo" },
            { key: "documentNo", label: "Mã phiếu" },
            { key: "inventoryType", label: "Loại phiếu" },
            { key: "inventoryDate", label: "Ngày chứng từ" },
            { key: "description", label: "Ghi chú" },
            { key: "customerName", label: "Khách hàng" },
          ],
          slots: ["createDate", "inventoryDate", "inventoryType", "action"],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: false,
          itemsPerPageSelect: {
            label: " ",
            values: [15, 20, 30, 50, 100],
            external: true,
          },
          pageSize: 20,
        },
        dataSource: {
          url: "/stock/check-flow",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    copyPhoneNumber(phoneNumber) {
      navigator.clipboard.writeText(phoneNumber);
    },
  },
  created: function () {},
  mounted() {},
  watch: {},
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>